<template>
    <div class="modal-mask" @click="close">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="content">

            <div class="modal-header">
              <i class="fas fa-times-circle" @click="close"></i>
              <slot name="header">
                default header
              </slot>
            </div>

            <div class="modal-body">
              <slot name="body">
                default body
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                default footer
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    methods: {
      close () {
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  margin: 0px auto;
  transition: all .3s ease;
  max-width: 600px;
  width: 100%;
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 10px 10px 15px rgba(0,0,0,0.2);
  text-align: center;
}

.content {
  margin: 0px auto;
  transition: all .3s ease;
  max-width: 600px;
  width: 100%;
  background: white;
  border-radius: 15px;
  padding: 25px 35px;
  box-shadow: 0px 0px 35px rgba(0,0,0,0.2);
  text-align: center;
}

.modal-container h3 {
  margin-top: 0;
  color: #413492;
  line-height: 35px;
  margin-bottom: 40px;
  font-size: 26px;
}

.modal-header { position: relative; }
.fa-times-circle {
  position: absolute;
  top: -40px;
  right: -50px;
  font-size: 46px;
  cursor: pointer;
}
.fa-times-circle:hover { color: #413492; }

.modal-body {
  margin: 20px 0 40px;
  text-align: left;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media (max-width: 1020px) {

  .modal-container p {font-size: 14px;}
  .modal-container h3 {  font-size: 21px;  line-height: 24px; margin-bottom: 20px; }
  
}
</style>
